<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    title="Create A New Workspace"
    class="add-dashboard-modal"
    >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Workspace Name:"
      >
        <b-form-input
          autofocus 
          type="text"
          v-model.trim="$v.name.$model"
          :class="{ 'is-invalid': $v.name.$error }"
          :disabled="inProgress"
          autocomplete="off"
        />
        <b-form-invalid-feedback
          v-if="!$v.name.required"
          >
          Title is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        style="display:none"
        v-if="!buildFromExcel"
        label="Template:"
      >
        <b-form-select
          v-model="templateDashboard"
          :disabled="inProgress"
          :options="templateDashboards"
        />
      </b-form-group>
      <b-form-group
        v-else
        label="Excel file:"
      >
        <div>
          <b-form-file
            v-model.trim="excelFile"
            class="custom-file-input"
            :class="{ 'is-invalid': $v.excelData.$error }"
            :disabled="inProgress"
            placeholder="Choose a file..."
            style="opacity: 1;"
          />
          <b-form-invalid-feedback
            v-if="!$v.excelData.required"
            >
            Excel file is required
          </b-form-invalid-feedback>
        </div>
        <b-alert
          variant="success"
          dismissible
          :show="excelDataProvided"
          @dismissed="resetExcelData"
          class="mt-3"
        >
          Excel data provided.
        </b-alert>
      </b-form-group>
      <div class="row"
        style="display:none"
      >
        <b-form-group class="col-md-6">
          <b-form-checkbox
            v-model="buildFromExcel"
          >
            Build from Excel
          </b-form-checkbox>
        </b-form-group>
        <b-form-group class="col-md-6">
          <b-form-checkbox v-model="isTemplate">is template</b-form-checkbox>
        </b-form-group>
      </div>
      <div>
        <b-button
          variant="success"
          type="submit"
          >
          Create Workspace
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'
// validations
import { required } from 'vuelidate/lib/validators'

let $ = window.$

export default {
  props: ['dashboards'],
  data () {
    return {
      inProgress: false,
      name: null,
      isTemplate: false,
      buildFromExcel: false,
      excelFile: null,
      excelData: null,
      excelDataProvided: false,
      templateDashboard: null,
    }
  },
  watch: {
    excelFile () {
      if (!this.excelFile) {
        this.excelData = null
        return
      }
      this.$readExcelFileToJSON(this.excelFile, (result) => {
        this.excelDataProvided = true
        this.excelData = result
      })
    }
  },
  computed: {
    templateDashboards () {
      const templateDashboards = []

      for (let dashKey in this.dashboards) {
        const dashboard = this.dashboards[dashKey]

        if (dashboard.isTemplate) templateDashboards.push({ text: dashboard.name, value: dashKey })
      }

      return templateDashboards
    }
  },
  methods: {
    open () {
      if (this.$refs.modal) this.$refs.modal.show()
    },
    async save () {
      // console.log(this.excelData)
      // return
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true

      this.$store.commit('addProcess', {
        process: 'newDashboard',
        message: 'Creating'
      })

      const data = {
        name: this.name,
        isTemplate: this.isTemplate,
      }

      const newDashKey = await db.dashboards.create(data)

      this.$emit('dashboardAdded')

      if (this.templateDashboard && !this.buildFromExcel) await db.dashboards.fillDashboardFromTemplate(this.templateDashboard, newDashKey)
      if (this.buildFromExcel) await db.dashboards.importFromExcel(this.excelData, newDashKey)

      this.$store.commit('deleteProcess', 'newDashboard')

      this.$router.push(`/dashboard/${newDashKey}`)
    },
    resetExcelData () {
      this.excelData = false
      this.excelFile = null
      this.excelDataProvided = false
    }
  },
  validations: {
    name: {
      required
    },
    excelData: {
      required () {
        if (!this.buildFromExcel) return true
        if (!this.excelData) return false
        return true
      }
    }
  }
}
</script>

<style>
.custom-file-input.is-invalid .custom-file-label {
  border: 1px solid #fb6340;
}
</style>
